import React, { useState } from 'react';
import Popup from './Card/Popup_v3';
import axios from 'axios'; // Assuming axios will be used for API calls

// const apiBaseUrl = process.env.REACT_APP_API_FACE_BASE_URL || 'https://comtruaduytan.com/api/markers/';//'https://comtruaduytan.com/backend/api/markers/'

// const apiEndpoint = process.env.REACT_APP_API_FACE_BASE_URL || 'https://192.168.1.217:3005/api/face'; //'https://comtruaduytan.com/api/face'; // Use the correct API endpoint

// const apiEndpoint = process.env.REACT_APP_API_FACE_BASE_URL || 'https://192.168.10.13:3005/api/face'; //'https://comtruaduytan.com/api/face'; // Use the correct API endpoint
const apiEndpoint = window.REACT_APP_CONFIG.REACT_APP_API_FACE_BASE_URL || 'https://192.168.10.13:3005/api/face';

// const apiEndpoint = process.env.REACT_APP_API_FACE_BASE_URL || 'https://comtruaduytan.com/api/face';

const maxSizeInMB = 40;


const MorderForm = () => {
    const [sourceFile, setSourceFile] = useState(null);
    const [targetFile, setTargetFile] = useState(null);
    const [sourceName, setSourceName] = useState('');
    const [targetName, setTargetName] = useState('');
    const [resultUrl, setResultUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [records, setRecords] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const handleSourceFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const allowedTypes = ['.png', '.jpg', '.jpeg', '.gif', '.bmp'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
            if (!allowedTypes.includes(fileExtension)) {
                setError('Please select a valid image file type: .png, .jpg, .jpeg, .gif, .bmp');
                setSourceFile(null);
                return;
            }
            setSourceFile(file);
            setError(null); // Clear error on new file selection
        }
    };

    const handleTargetFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const allowedImageTypes = ['.png', '.jpg', '.jpeg', '.gif', '.bmp'];
            const allowedVideoTypes = ['.mp4', '.mkv'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

            if (file.type.startsWith('image/')) {
                if (!allowedImageTypes.includes(fileExtension)) {
                    setError('Please select a valid image file type: .png, .jpg, .jpeg, .gif, .bmp');
                    setTargetFile(null);
                    return;
                }
            } else if (file.type.startsWith('video/')) {
                if (!allowedVideoTypes.includes(fileExtension)) {
                    setError('Please select a valid video file type: .mp4, .mkv');
                    setTargetFile(null);
                    return;
                }
            } else {
                setError('Please select a valid image or video file type.');
                setTargetFile(null);
                return;
            }

            if (file.size > maxSizeInMB * 1024 * 1024 && file.type.startsWith('video/')) {
                setError(`Video size must be less than ${maxSizeInMB}MB.`);
                setTargetFile(null);
                return;
            }

            setTargetFile(file);
            setError(null); // Clear error on new file selection
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);
        setResultUrl(''); // Clear previous result

        if (!sourceFile || !targetFile) {
            setError('Please select both a source image and a target image/video.');
            setIsLoading(false);
            return;
        }

        const formData = new FormData();
        formData.append('sourceImage', sourceFile);
        formData.append('targetMedia', targetFile);
        if (sourceName) formData.append('sourceName', sourceName);
        if (targetName) formData.append('targetName', targetName);

        try {
            // --- API Call ---
            const token = localStorage.getItem('token'); // Retrieve token from localStorage

            if (!token) {
                setError('Authentication token not found. Please log in.');
                setIsLoading(false);
                return;
            }

            console.log('Submitting to:', apiEndpoint);
            // console.log('FormData:', formData); // Optional: Log FormData contents if needed (can be tricky)

            const response = await axios.post(apiEndpoint, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`, // Add the Authorization header
                },
            });

            console.log('API Response:', response.data);

            // Handle the response - the backend returns the created job object
            // The actual resultUrl might be populated later by a background process.
            // For now, we can indicate success or show the job status.
            // If the response immediately contains the result URL (unlikely for processing jobs):
            // setResultUrl(response.data.data?.resultUrl || '');

            // Example: Set a success message or status instead of resultUrl directly
            setError(null); // Clear previous errors
            // You might want to display response.data.message or response.data.data.status
            alert(`Job created successfully! Status: ${response.data.data?.status || 'N/A'}`); // Simple alert for now

        } catch (err) {
            console.error('Submission failed:', err.response || err);
            setError(err.response?.data?.message || 'An error occurred during submission.');
        } finally {
            setIsLoading(false);
        }
    };

    const fetchRecords = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const token = localStorage.getItem('token'); // Retrieve token from localStorage
            if (!token) {
                setError('Authentication token not found. Please log in.');
                setIsLoading(false);
                return;
            }

            const response = await axios.get(apiEndpoint, { // Use the existing apiEndpoint
                headers: {
                    'Authorization': `Bearer ${token}`, // Add the Authorization header
                },
            });
            console.log('GET Response:', response.data);
            // console.log('GET Response data:', response.data.data);

            // setRecords(response.data.data || []); // Assuming the records are in response.data.data
            setRecords(response.data || []); // Assuming the records are in response.data.data

        } catch (err) {
            console.error('Error fetching records:', err.response || err);
            setError(err.response?.data?.message || 'Failed to fetch records.');
        } finally {
            setIsLoading(false);
        }
    };

    const displayRecords = () => {
        if (!records || records.length === 0) {
            return <p>No records to display.</p>;
        }

        return (
            <div style={{ display: 'flex', overflowX: 'auto' }}>
                {records.map((record) => (
                    <div key={record.id} style={{
                        margin: '0 10px',
                        border: '1px solid #ccc',
                        padding: '10px',
                        minWidth: '200px',
                        borderRadius: '8px',
                        textAlign: 'left', // Aligns text to the left
                         }}>
                        {/* Display record information here. Adjust based on your record structure */}
                        {/* <p style={{ color: '#333', fontSize: '24px', marginTop: '40px', fontFamily: "'Nunito', sans-serif",
                        // WebkitTextStroke: '1px black',
                        }}>Record ID: {record.id}</p> */}
                        {/* Example: Display sourceName and targetName if available */}
                        {record.sourceName && <p
                            style={{

                                // padding: '10px',
                                borderRadius: '8px',
                                fontFamily: "'Nunito', sans-serif",
                                color: '#777',
                                marginTop: '20px',


                            }}
                        >Source Name: {record.sourceName}</p>}
                        {record.targetName && <p
                            style={{

                                // padding: '10px',
                                borderRadius: '8px',
                                fontFamily: "'Nunito', sans-serif",
                                color: '#777',
                                marginTop: '20px'

                            }}
                        >Target Name: {record.targetName}</p>}
                        {/* {record.sourceImageUrl && <p>Source Image URL: {record.sourceImageUrl}</p>}
                        {record.targetMediaUrl && <p>Target Media URL: {record.targetMediaUrl}</p>} */}
                        {/* Display media */}
                        <div style={{ marginTop: '10px' }}>
                            <p styple={{ fontSize: '24px',                 WebkitTextStroke: '4px black',
}}>Media:</p>
                            <ul style={{ padding: '0', listStyle: 'none', marginTop: '5px' }}>
                                 {record.sourceImageUrl && (
                                    <li style={{ marginBottom: '5px' }}>
                                        <p style={{
                                            borderRadius: '8px',
                                            fontFamily: "'Nunito', sans-serif",
                                            color: '#777',
                                            marginTop: '20px'
                                        }}>Source:</p>
                                        <div
                                            onClick={() => {
                                                setSelectedRecord(record);
                                                setShowPopup(true);
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <img
                                                src={record.sourceImageUrl.startsWith('http') ? record.sourceImageUrl : `${record.sourceImageUrl}`}
                                                alt="Source"
                                                style={{ maxWidth: '100%', height: 'auto', borderRadius: '4px' }}
                                            />
                                        </div>
                                    </li>
                                )}
                                {console.log("Rendering Source Image:", record.sourceImageUrl)}

                                {record.targetMediaUrl && (
                                    <li style={{ marginBottom: '5px' }}>
                                        <p style={{
                                            borderRadius: '8px',
                                            fontFamily: "'Nunito', sans-serif",
                                            color: '#777',
                                            marginTop: '20px'
                                        }}>Target:</p>
                                        <div
                                            onClick={() => {
                                                setSelectedRecord(record);
                                                setShowPopup(true);
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {record.targetMediaUrl.endsWith('.mp4') ? (
                                                <video controls style={{ maxWidth: '100%', height: 'auto', borderRadius: '4px' }}>
                                                    <source src={record.targetMediaUrl.startsWith('http') ? record.targetMediaUrl : `https://${record.targetMediaUrl}`} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : (
                                                <img
                                                    src={record.targetMediaUrl.startsWith('http') ? record.targetMediaUrl : `https://${record.targetMediaUrl}`}
                                                    alt="Target"
                                                    style={{ maxWidth: '100%', height: 'auto', borderRadius: '4px' }}
                                                />
                                            )}
                                        </div>
                                    </li>
                                )}
                                <li style={{ marginBottom: '5px' }}>
                                    <p style={{
                                        borderRadius: '8px',
                                        fontFamily: "'Nunito', sans-serif",
                                        color: '#777',
                                        marginTop: '20px'
                                    }}>Result:</p>
                                    <div
                                        onClick={() => {
                                            setSelectedRecord(record);
                                            setShowPopup(true);
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {record.resultUrl ? (
                                            record.resultUrl.endsWith('.mp4') ? (
                                                <video controls style={{ maxWidth: '100%', height: 'auto', borderRadius: '4px' }}>
                                                    <source src={record.resultUrl.startsWith('http') ? record.resultUrl : `https://${record.resultUrl}`} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : (
                                                <img
                                                    src={record.resultUrl.startsWith('http') ? record.resultUrl : `https://${record.resultUrl}`}
                                                    alt="Result"
                                                    style={{ maxWidth: '100%', height: 'auto', borderRadius: '4px' }}
                                                />
                                            )
                                        ) : (
                                            <p style={{
                                                borderRadius: '8px',
                                                fontFamily: "'Nunito', sans-serif",
                                                color: '#777',
                                                marginTop: '20px'
                                            }}>Status: Pending</p>
                                        )}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    // Basic modern styling
    const styles = {
        container: {
            fontFamily: "'Nunito', sans-serif",
            padding: '25px',
            maxWidth: '300px',
            margin: '40px auto',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            boxShadow: '0 1px 6px rgba(0, 0, 0, 0.15)',
            // border: '1px solid #e0e0e0',
        },
        heading: {
            marginBottom: '2px',
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#000',
            paddingLeft: '5px',
            fontWeight: '800',
            WebkitTextStroke: '1px black',
            textAlign: 'center',
        },
        description: {
            fontSize: '0.9rem',
            color: '#777',
            marginTop: '0',
            marginBottom: '15px',
            paddingLeft: '5px'
        },
        formGroup: {
            marginBottom: '20px',
        },
        label: {
            display: 'block',
            marginBottom: '8px',
            color: '#555',
            fontWeight: '500',
            fontFamily: "'Nunito', sans-serif"
        },
        input: {
            width: '100%',
            padding: '10px 12px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '16px',
            boxSizing: 'border-box', // Prevents padding from increasing element size
            fontFamily: "'Nunito', sans-serif"
        },
        fileInput: {
            display: 'block', // Ensure it takes full width
            padding: '4px 4px', // Adjust padding as needed
            fontFamily: "'Nunito', sans-serif"
        },
        button: {
            width: '100%',
            // height: '400px',
            padding: '12px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
            marginTop: '10px',
            opacity: isLoading ? 0.7 : 1,
            fontFamily: "'Nunito', sans-serif"
        },
        buttonHover: { // Example inline style for hover (better handled with CSS classes/modules)
            // backgroundColor: '#0056b3',
        },
        error: {
            color: '#dc3545',
            marginTop: '15px',
            textAlign: 'center',
            fontSize: '14px',
            fontFamily: "'Nunito', sans-serif"
        },
        resultContainer: {
            marginTop: '30px',
            paddingTop: '20px',
            borderTop: '1px solid #eee',
            textAlign: 'center',
            fontFamily: "'Nunito', sans-serif"
        },
        resultMedia: {
            maxWidth: '100%',
            maxHeight: '400px',
            marginTop: '10px',
            borderRadius: '4px',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
            fontFamily: "'Nunito', sans-serif"
        },
        loadingText: {
            textAlign: 'center',
            color: '#007bff',
            marginTop: '10px',
            fontFamily: "'Nunito', sans-serif"
        }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.heading}>Face Processing</h2>
            {showPopup && selectedRecord && (
                <Popup property={selectedRecord} setShowPopup={setShowPopup} />
            )}
            <form onSubmit={handleSubmit}>
                <div style={styles.formGroup}>
                    <label htmlFor="sourceFile" style={styles.label}>Source Image:</label>
                    <input
                        type="file"
                        id="sourceFile"
                        accept="image/*"
                        onChange={handleSourceFileChange}
                        required
                        style={{ ...styles.input, ...styles.fileInput }}
                    />
                </div>

                <div style={styles.formGroup}>
                    <label htmlFor="sourceName" style={styles.label}>Source Name (Optional):</label>
                    <input
                        type="text"
                        id="sourceName"
                        value={sourceName}
                        onChange={(e) => setSourceName(e.target.value)}
                        placeholder="e.g., Original Portrait"
                        style={styles.input}
                    />
                </div>

                <div style={styles.formGroup}>
                    <label htmlFor="targetFile" style={styles.label}>Target Image/Video(Max 30s):</label>
                    <input
                        type="file"
                        id="targetFile"
                        accept="image/*,video/*"
                        onChange={handleTargetFileChange}
                        required
                        style={{...styles.input, ...styles.fileInput}}
                    />
                </div>

                <div style={styles.formGroup}>
                    <label htmlFor="targetName" style={styles.label}>Target Name (Optional):</label>
                    <input
                        type="text"
                        id="targetName"
                        value={targetName}
                        onChange={(e) => setTargetName(e.target.value)}
                        placeholder="e.g., Style Reference"
                        style={styles.input}
                    />
                </div>

                <button
                    type="submit"
                    style={styles.button}
                    disabled={isLoading}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#0056b3'} // Basic hover effect
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
                >
                    {isLoading ? 'Processing...' : 'Submit'}
                </button>

                {isLoading && <p style={styles.loadingText}>Uploading and processing files...</p>}
                {error && <p style={styles.error}>{error}</p>}
            </form>

            {resultUrl && (
                <div style={styles.resultContainer}>
                    <h3 style={{ color: '#333', marginBottom: '15px' }}>Result:</h3>
                    {targetFile?.type.startsWith('video/') ? (
                        <video controls src={resultUrl} style={styles.resultMedia}>
                            Your browser does not support the video tag.
                        </video>
                    ) : (
                        <img src={resultUrl} alt="Processing result" style={styles.resultMedia} />
                    )}
                </div>
            )}

            <button onClick={fetchRecords} style={styles.button} disabled={isLoading}>
                {isLoading ? 'Loading Records...' : 'View Results'}
            </button>

            {error && <p style={styles.error}>{error}</p>}
            <div style={styles.resultContainer}>
                {displayRecords()}
            </div>
        </div>
    );
};

export default MorderForm;
